<div class="m-auto kick-motto cursor-enable" (click)="goToScoreTable()">
    <img 
        class="m-auto" 
        mat-card-image src="assets\img\AtosEvidenBall.png" 
        alt="AtosEvidenBall"
    >
    <!-- Card header -->
    <mat-card-header class="m-auto">
        <!-- Header text -->
        <p class="kick-motto-style">Kick it like <span class="atos-color">Atos</span> & <span class="eviden-color">Eviden</span></p>
    </mat-card-header>
</div>